import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Fired right before the session is torn down due to idle/absolute timeout
 * or a 401 from the API — NOT on a manual "Logout" click. Active forms
 * (e.g. Add/Edit Contest) subscribe to this to auto-save a draft before
 * the app redirects to the login page.
 */
@Injectable({
  providedIn: 'root',
})
export class SessionEventService {
  private sessionTimeoutSource = new Subject<void>();
  sessionTimeout$ = this.sessionTimeoutSource.asObservable();

  notifySessionTimeout(): void {
    this.sessionTimeoutSource.next();
  }
}
